<template lang="pug">
  .info-message(v-bind:class="type")
    slot
</template>

<script>
export default {
  props: ['type']
}
</script>

<style lang="scss" scoped>
  .info-message {
    background:#23ad65;
    border-bottom: 5px solid #177d48;
    background-image:url('~@/assets/images/star-white.svg');
    background-repeat: no-repeat;
    background-size: 24px;
    &.w {
      width:100%;
    }
    background-position: top 19px right 19px;
    color:#fefefe;
    * {
      color:#fff;
    }
    margin-bottom:15px;
    padding:20px;
    font-size:16px;
  }
</style>